<template>
  <div
    v-if="props.text"
    class="seo-text"
    :class="{ expanded: !isCollapsed }"
  >
    <!-- eslint-disable vue/no-v-html -->
    <div ref="content" class="seo-text__content" v-html="sanitize(props.text)" />
    <!-- eslint-enable vue/no-v-html -->
    <div v-if="isCollapsed" class="seo-text__overlay">
      <button class="seo-text__button" @click="isCollapsed = false">
        <div class="seo-text__dot" />
        <div class="seo-text__dot" />
        <div class="seo-text__dot" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  computed, inject, onMounted,
  ref,
} from 'vue';

import { sanitize } from '@/utils/sanitize';

defineOptions({
  name: 'seo-text',
});

interface IProps {
  text: string,
}
const props = withDefaults(defineProps<IProps>(), {
  text: '',
});
const adaptive = inject('adaptive') as { isDesktop: boolean };
const isCollapsedModeOn = computed(() => !adaptive.isDesktop);
const COLLAPSED_MAX_HEIGHT = 240;
const content = ref<HTMLInputElement>();
const isCollapsed = ref(true);
const getState = () => {
  if (!content.value?.offsetHeight) return false;
  return isCollapsedModeOn.value && content.value.offsetHeight > COLLAPSED_MAX_HEIGHT;
};
onMounted(() => {
  isCollapsed.value = getState();
});
</script>

<style lang="scss">
.seo-text {
  position: relative;
  overflow: hidden;
  height: 240px;

  &.expanded {
    height: auto;
  }

  @include breakpoint("desktop") {
    height: auto;
    overflow: auto;
  }

  &__content {
    --font-size: 12px;
    --line-height: 16px;
    --offset: 4px;;

    // TODO: Исправить на использование БЭМ-селекторов
    // stylelint-disable-next-line selector-max-universal
    &, & * {
      font-family: Gilroy, sans-serif;
      font-size: var(--font-size) !important;
      line-height: var(--line-height) !important;
      font-style: normal !important;
      text-decoration: none !important;
      color: $gray !important;
      margin-bottom: var(--offset) !important;
    }

    & h1,h2,h3,h4 {
      font-weight: 600 !important;
      margin-top: 0;
    }

    & p {
      font-weight: normal !important;
      margin-bottom: var(--offset);
    }

    @include breakpoint("desktop") {
      --font-size: 14px;
      --line-height: 20px;
      --offset: 8px;
    }
  }

  &__overlay {
    background: linear-gradient(180deg, transparent 0%, #FFF 100%);
    position: absolute;
    height: 104px;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;

    @include breakpoint("desktop") {
      display: none;
    }
  }

  &__button {
    background: $white;
    width: 48px;
    height: 24px;
    border: 1px solid $gray_lu;
    border-radius: 4px;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
  }

  &__dot {
    width: 4px;
    height: 4px;
    background: $black;
    border-radius: 4px;
  }
}
</style>
